import { useState, useCallback } from "react";
import {
  createProduct,
  updateProduct,
  deleteProduct,
  toggleProductStatus,
  getAllProducts,
  rotateProductImage,
} from "../API/endpoint";

export const useProducts = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const loadProducts = useCallback(async () => {
    try {
      setLoading(true);
      const data = await getAllProducts();
      setProducts(data);
      setError("");
    } catch (err) {
      setError("Erreur lors du chargement des produits");
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, []);

  const handleCreateProduct = useCallback(async (productData) => {
    try {
      await createProduct(productData);
      await loadProducts();
      setError("");
      return true;
    } catch (err) {
      setError("Erreur lors de la création du produit");
      console.error(err);
      return false;
    }
  }, [loadProducts]);

  const handleUpdateProduct = useCallback(async (id, productData) => {
    try {
      await updateProduct(id, productData);
      await loadProducts();
      setError("");
      return true;
    } catch (err) {
      setError("Erreur lors de la mise à jour du produit");
      console.error(err);
      return false;
    }
  }, [loadProducts]);

  const handleDeleteProduct = useCallback(async (id) => {
    if (window.confirm("Êtes-vous sûr de vouloir supprimer ce produit ?")) {
      try {
        await deleteProduct(id);
        await loadProducts();
        setError("");
        return true;
      } catch (err) {
        setError("Erreur lors de la suppression du produit");
        console.error(err);
        return false;
      }
    }
    return false;
  }, [loadProducts]);

  const handleToggleStatus = useCallback(async (id, currentStatus) => {
    try {
      await toggleProductStatus(id, !currentStatus);
      await loadProducts();
      setError("");
      return true;
    } catch (err) {
      setError("Erreur lors du changement de statut");
      console.error(err);
      return false;
    }
  }, [loadProducts]);

  const handleRotateImage = useCallback(async (id) => {
    try {
      setLoading(true);
      await rotateProductImage(id);
      await loadProducts();
      setError("");
      return true;
    } catch (err) {
      setError("Erreur lors de la rotation de l'image");
      console.error(err);
      return false;
    } finally {
      setLoading(false);
    }
  }, [loadProducts]);

  return {
    products,
    loading,
    error,
    setError,
    loadProducts,
    handleCreateProduct,
    handleUpdateProduct,
    handleDeleteProduct,
    handleToggleStatus,
    handleRotateImage,
  };
};
